(ns practitest.frontend.components2.tabs
  (:require [practitest.frontend.common.dom :as dom]))

(defn
  ^{:component? true}
  tabs-container
  "Tabs container (should be used with corresponding `tab` component)"
  [{:keys [on-toggle active-tab-id] :as props} & tabs]
  (let [last-index (dec (count tabs))]
    [:div.tabs-container
     (doall (map-indexed
              (fn [idx tab]
                (let [[comp tab-props & children] tab
                      tab-id (:tab-id tab-props)]
                  (with-meta
                    (into [comp
                           ;; splice additional props
                           (assoc tab-props :active? (= tab-id active-tab-id)
                                            :idx idx
                                            :on-toggle on-toggle
                                            :last? (= idx last-index))]
                          children)
                    {:key tab-id})))
              (remove nil? tabs)))]))

(defn ^{:component? true}
  tab
  "Tab element for tabs container component"
  [{:keys [active? last? tab-id on-toggle header? custom-class icon]} & children]
  [:<>
   [:div.tab
    ;; This data-tabid is used by keyboard shortcuts (pending refactoring)
    (-> {:data-tabid tab-id
         :class (str custom-class " " (dom/classes-pairs :active active? :header-tab header?))
         :on-click (fn [e]
                     (when on-toggle
                       (on-toggle tab-id)))}
        (dom/add-test-id tab-id))
    (if icon
      [:span.with-icon
       [:span.icon icon]
       [:span.text (into [:<>] children)]]
      (into [:<>] children))]
   (when-not (or header? last?)
     [:span.tab-delimiter])])
